module.exports = __webpack_public_path__ + "static/img/use04.b12fd41.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/course/mo/use04.png
// module id = ZjwQ
// module chunks = 10